export default {
  SET_CONSUMERS: function (state, payloads) {
    state.consumers = payloads;
  },
};
